import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowDown = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.29289 7.29289C4.68342 6.90237 5.31658 6.90237 5.70711 7.29289L12.0001 13.5858L18.293 7.29289C18.6835 6.90237 19.3167 6.90237 19.7072 7.29289C20.0978 7.68342 20.0978 8.31658 19.7072 8.70711L12.7072 15.7072C12.3166 16.0977 11.6835 16.0977 11.293 15.7072L4.29289 8.70711C3.90237 8.31658 3.90237 7.68342 4.29289 7.29289Z", fill: color }));
};
export default factorySvgIcon(SvgArrowDown);
//# sourceMappingURL=SvgArrowDown.js.map